import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  EventEmitter,
  Output,
  OnDestroy,
} from "@angular/core";
import { FormBuilder, FormGroup, FormControl } from "@angular/forms";
import { NgxFileDropEntry } from "ngx-file-drop";
import { EMPTY, from, merge, Observable, Subject, Subscription } from "rxjs";
import { ChatService } from "../../chat.service";
import { PlanitService } from "./planit.service";
import {
  catchError,
  debounceTime,
  finalize,
  map,
  switchMap,
  take,
  takeUntil,
  takeWhile,
} from "rxjs/operators";
import * as PROMPTS from "./prompt.constant";
import { Chat, Message, MessageData } from "../../types";
import * as SAMPLE_DATA from "./sample.constant";
import { AskGenAiService } from "src/app/askGenAi.service";

function convertHoursToTime(hours) {
  // Set the start time to 9am
  let startTime = 9;

  if (hours > 8) {
    startTime = 8;
  }

  // Calculate the end time
  let endTime = startTime + Math.floor(hours);
  let endTimeMinutes = (hours - Math.floor(hours)) * 60;

  // Adjust end time if minutes are greater than 0
  let endTimeMinutesString = '00';
  if (endTimeMinutes > 0) {
    endTimeMinutesString = endTimeMinutes < 10 ? '0' + Math.floor(endTimeMinutes) : String(Math.floor(endTimeMinutes));
  }

  let endTimeString = '';
  // Check if the end time is greater than or equal to 12
  if (endTime >= 12) {
    // If so, adjust the end time to "pm"
    if (endTime !== 12) {
      endTime -= 12;
    }
    endTimeString = endTime + ':' + endTimeMinutesString + 'pm';
  } else {
    // If not, keep the end time as "am"
    endTimeString = endTime + ':' + endTimeMinutesString + 'am';
  }

  // Format the time range
  let timeRange = startTime + ':00am to ' + endTimeString;

  return timeRange;
}


@Component({
  selector: "app-planit",
  templateUrl: "./planit.component.html",
  styleUrls: ["./planit.component.css"],
})
export class PlanitComponent implements OnInit, OnDestroy {
  @Input() subscription_id: string = "";
  @Output() displayResponse = new EventEmitter<any>();

  public formJson;
  form: FormGroup;
  public uploadIcon = false;
  showForm = false;
  loading: boolean = false;
  isDestroyed: boolean = false;
  error = {
    "textarea": false,
    "days": false,
    "hours": false,
  };

  constructor(
    private formBuilder: FormBuilder,
    private chatService: ChatService,
    private planitService: PlanitService
  ) {}

  ngOnInit() {
    this.getFormJson();
    this.planitService.planitLoading.pipe(takeWhile(() => !this.isDestroyed))
      .subscribe((isLoading) => {
        this.loading = isLoading;
      })
  }

  getFormJson() {
    this.chatService.getFormJson().subscribe((res) => {
      this.formJson = res.data;
      this.initForm();
    });
  }

  initForm() {
    this.form = this.formBuilder.group(
      this.formJson.reduce(
        (acc, control) => ({ ...acc, [control.name]: "" }),
        {}
      )
    );
    this.showForm = true;
  }

  calculateInitialPrompt() {
    let promptInput = PROMPTS.prefix;

    // add topic description
    promptInput += `You will be given the topic: ${this.form.value.textarea}.\n`;

    // add timeframe
    this.form.value.days = Math.abs(this.form.value.days);
    this.form.value.hours = Math.abs(this.form.value.hours);
    promptInput += `The duration of your workshop is ${
      this.form.value.days
    } days, each day from ${convertHoursToTime(
      this.form.value.hours
    )}. Be very strict about the time. Make sure to hold that given timeframe. ${convertHoursToTime(
      this.form.value.hours
    )} \n`;

    // add lunch
    /* if (parseInt(this.form.value.hours) >= 6) {
      promptInput += "Make sure to include a one hour lunch break every day. ";
    } */

    // add coffee break
    /* if (parseInt(this.form.value.hours) >= 3) {
      let coffeebreak = "Also include one 15 minutes coffee break.\n";
      if (parseInt(this.form.value.hours) >= 5) {
        coffeebreak = "Also include two 15 minutes coffee breaks.\n";
      }
      promptInput += coffeebreak;
    } */

    promptInput += 'Only give the first day!\n';
    promptInput += PROMPTS.output2;

    return promptInput;
  }
  validateInput() {
    this.resetError();

    if (typeof this.form.value.days === 'string' || this.form.value.days instanceof String) {
      this.form.value.days = parseFloat(this.form.value.days);
    }
    if (typeof this.form.value.hours === 'string' || this.form.value.hours instanceof String) {
      this.form.value.hours = parseFloat(this.form.value.hours);
    }

    if (this.form.value.textarea === '') {
      this.error.textarea = true;
    }

    if (
      this.form.value.days > 5 || this.form.value.days < 1
      || !Number.isInteger(this.form.value.days)
    ) {
      this.error.days = true;
    }
    if (
      this.form.value.hours > 10 || this.form.value.hours < 1
      || !Number.isInteger(this.form.value.hours)
    ) {
      this.error.hours = true;
    }

  }

  resetError() {
    this.error = {
      "textarea": false,
      "days": false,
      "hours": false,
    };
  }

  onSubmit() {
    console.log("Formvalue", this.form.value);
    this.validateInput();
    if (Object.values(this.error).every(val => !val)) {
      this.planitService.agendaTime = convertHoursToTime(this.form.value.hours);
      const promptInput = this.calculateInitialPrompt();
      this.planitService.generateWorkshop(this.form.value.textarea, this.form.value.days, promptInput);
      console.log(promptInput);
      const input = {
        promptString: promptInput,
        model: "chat-bison"
      }
      // this.displayResponse.emit(input);
    }
  }

  // Form elements

  // File on drop
  public drop(files: NgxFileDropEntry[]): void {
    this.uploadIcon = true;

    files.forEach((file) => {
      if (file.fileEntry.isFile) {
        const dropped = file.fileEntry as FileSystemFileEntry;
        dropped.file(async (droppedFile: File) => {
          from(this.convertImageToBase64(droppedFile))
            .pipe(
              //   switchMap((iconUrl) =>
              //     // this.assetRepository.setData("marketplace_data.asset.icon_url",iconUrl)
              //     console.log(iconUrl)
              //   ),
              finalize(() => (this.uploadIcon = false)),
              catchError((error: Error) => {
                // this.alertService.error(error);

                return EMPTY;
              }),
              take(1)
            )
            .subscribe();
        });
      }
    });
  }

  /**
   * convert an image to base64
   *
   */
  public convertImageToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      if (file.size / (1024 * 512) >= 1) {
        reject(`Filesize is too big, maximum allowed file size is 512kb.`);
      }

      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.readAsDataURL(file);
    });
  }

  prefillSampleData() {
    this.form.patchValue(SAMPLE_DATA.form_value);
  }

  ngOnDestroy(): void {
      this.isDestroyed = true;
  }
}
